import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid';
import { ITEM_CLICK_EVENT } from '../../../../search/search-constants';
import { SearchEvent } from '../../../../search/models/search-event';

@Component({
  selector: 'lfwms-reship-cell-renderer',
  templateUrl: './reship-cell-renderer.component.html',
  styleUrls: ['./reship-cell-renderer.component.css']
})
export class ReshipCellRendererComponent implements ICellRendererAngularComp {
/* Component is Used in Ship-Reship popup, as well as Finalize-Refinalize Popup of Wave Control Actions. */

  public params: any;
  public cellValue: any = [];
  public textColor;
  public templateId;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    // values are displayed in colurs according to type.
    if (params.colDef.colId === 'errorType' || params.colDef.colId === 'errorMsg' || params.colDef.colId === 'type') {
      this.templateId = 2;
      switch (params.data[params.colDef.colId].cVal.toUpperCase()) {
        case 'FAILURE':
          this.textColor = 'red';
          break;
        case 'ERROR':
          this.textColor = 'red';
          break;
        case 'ERRORMSG':
          this.textColor = 'red';
          break;
        case 'SUCCESSFUL':
          this.textColor = 'green';
          break;
        case 'WARNING':
          this.textColor = 'orange';
          break;
        case 'WARNINGMSG':
          this.textColor = 'orange';
          break;
      }
    } else if (params.colDef.colId === 'isSelected') {
      this.templateId = 1;
    } else if (params.colDef.colId === this.params.context.componentParent
      .searchService.searchParams.idProperty) {
      this.templateId = 3;
    }
    // console.log(params, params.value)
  }


  public refresh(params: any): boolean {
    this.params = params;
    this.cellValue = this.params.value.cVal;
    return true;
  }
  // LFWM-3071-triggered when hyperLink(mbolKey) is clicked.
  public detailItemClicked(itemClicked: string) {
    const searchService = this.params.context.componentParent.searchService;
    const event = new SearchEvent(ITEM_CLICK_EVENT);
    event.selectedItemId = itemClicked;
    searchService.publishEvent(event);
  }

  // public addLogicalOperation(operatorValue: string) {
  //   this.params.value.cVal = operatorValue;
  // }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/wave-ship-reship-popup/custom-cell-renderers/reship-cell-renderer/reship-cell-renderer.component.ts